import sanitizeHtml from "sanitize-html";

const OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: ["p", "br", "b", "strong", "i", "em", "u", "s", "strike", "a", "code", "blockquote"],
  allowedAttributes: { a: ["href", "target", "rel"] },
  allowedSchemes: ["http", "https", "mailto", "tel"],
  transformTags: {
    // Текст пишет владелец витрины, а страница индексируется
    a: sanitizeHtml.simpleTransform("a", {
      target: "_blank",
      rel: "nofollow noindex noopener noreferrer",
    }),
  },
};

export const renderRichText = (html?: string | null): string =>
  sanitizeHtml(String(html || ""), OPTIONS);

export const isRichTextEmpty = (html?: string | null): boolean =>
  !String(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();
